import { configureStore } from "@reduxjs/toolkit"
import rootReducer from "./reducers/rootReducer"

const store = configureStore({
  reducer: rootReducer,
  // middleware omitted — configureStore includes thunk + serializability check by default
})

export default store
